// extracted by mini-css-extract-plugin
module.exports = {"select":"select_select__1sfRQ","selectNoOutline":"select_selectNoOutline__CT3iA"};